import { Availability, InventoryStatus } from 'src/types';

export const isOutOfStock = (inventoryStatus: InventoryStatus) =>
  inventoryStatus === 'out_of_stock';

export const isSuspended = (availability: Availability, available: boolean) =>
  !available && availability === 'suspended';

export const isMadeToOrder = (inventoryStatus: InventoryStatus) =>
  inventoryStatus === 'made_to_order';
